// extracted by mini-css-extract-plugin
export default {"wrapper":"PhanKhu_wrapper__lz+fd","container":"PhanKhu_container__Zke5I","content":"PhanKhu_content__SxPRA"};